module.exports = __webpack_public_path__ + "media/images/icons/icon_moins-3778bc52a80cbac9dc09d10b847839da.svg";